import React from 'react';
import Raven from 'raven-js';
import injectTapEventPlugin from 'react-tap-event-plugin';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import CircularProgress from 'material-ui/CircularProgress';
import { ApolloProvider } from 'react-apollo';
import apolloClient from './services/apolloClient';
import TaskboardAppBar from './components/appBar/TaskboardAppBar';
import OverlayController from './components/overlay/OverlayController';
import userContext from './services/userContext';
import extendOverlayController from './utils/extendOverlayController';
import './App.css';
import './form-controls.css';
import './components/material/MaterialList.css';
import config from './config';
import resize from './utils/onResize';
// import logo from './logo.svg';

injectTapEventPlugin();
resize.addResizeEventListener();
extendOverlayController();

if (config.sentryDSN) {
  Raven.config(config.sentryDSN).addPlugin(require('raven-js/plugins/console')).install();
}

class App extends React.Component {
/*
    oldStuff() {
        return (
            <div className="App">
                <div className="App-header">
                    <img src={logo} className="App-logo" alt="logo" />
                    <h2>Welcome to React</h2>
                </div>
                <p className="App-intro">
                    To get started, edit <code>src/App.js</code> and save to reload.
                </p>
            </div>
        );
    }
*/

    constructor(props) {
        super(props);

        if (config.env !== 'prod') {
            document.title += ` (${config.env})`;
        }

        this.state = {
            loadingUserState: true,
            isLoggedIn: false
        };

        userContext.fetchCurrentUser()
            .then(user => {
                this.setState({
                    loadingUserState: false,
                    isLoggedIn: user !== null
                });
            })
            .catch(error => {
                this.setState({
                    loadingUserState: false,
                    isLoggedIn: false
                });
                console.error('could not fetch user, error:', error);
                OverlayController.showErrorAlert(error);
            });
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.isLoggedIn !== userContext.isLoggedIn()) {
            this.setState({
                loadingUserState: false,
                isLoggedIn: userContext.isLoggedIn()
            });
        }
    }

    render() {
        if (this.state.loadingUserState) {
            return (
                <MuiThemeProvider>
                    <CircularProgress className="activityIndicator"/>
                </MuiThemeProvider>
            );
        }
        return (
            <MuiThemeProvider>
                <ApolloProvider client={apolloClient}>
                    <div id="app">
                        <TaskboardAppBar isLoggedIn={this.state.isLoggedIn}/>
                        <div id="appContentContainer">{this.props.children}</div>
                        <OverlayController/>
                    </div>
                </ApolloProvider>
            </MuiThemeProvider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js